const API_INVESTIGATION_DETAILS_FIELDS = [
    'details.translations.title',
    'details.translations.message',
    'details.icons.rd_details_icons_id.translations.icon',
    'details.icons.rd_details_icons_id.translations.description'
];
const API_INVESTIGATION_COMMITMENT_FIELDS = [
    'commitment_section.image',
    'commitment_section.translations.commitment_title',
    'commitment_section.translations.commitment_text',
    'commitment_section.translations.subtitle',
    'commitment_section.icons.rd_commitment_logos_id.icon',
    'commitment_section.icons.rd_commitment_logos_id.translations.description',
    'commitment_section.metrics.rd_commitment_metrics_id.value',
    'commitment_section.metrics.rd_commitment_metrics_id.translations.name',
    'commitment_section.metrics.rd_commitment_metrics_id.translations.unit'
];
const API_INVESTIGATION_EVENTS_FIELDS = [
    'events_section.translations.title',
    'events_section.translations.text',
    'events_section.translations.button_link',
    'events_section.translations.button_name',
    'events_section.translations.file',
    'events_section.translations.subtitle',
    'events_section.icons.rd_event_logos_id.icon',
    'events_section.icons.rd_event_logos_id.translations.description',
    'events_section.metrics.rd_events_metrics_id.value',
    'events_section.metrics.rd_events_metrics_id.translations.name',
    'events_section.metrics.rd_events_metrics_id.translations.unit'
];
const API_INVESTIGATION_PROJECTS_FIELDS = [
    'project_section.translations.title',
    'project_section.translations.text',
    'project_section.projects.rd_projects_id.translations.name',
    'project_section.projects.rd_projects_id.translations.button_link',
    'project_section.projects.rd_projects_id.translations.button_name',
    'project_section.projects.rd_projects_id.translations.file',
    'project_section.projects.rd_projects_id.translations.description',
    'project_section.projects.rd_projects_id.translations.institutions',
    'project_section.projects.rd_projects_id.images.rd_projects_images_id.image',
    'project_section.projects.rd_projects_id.images.rd_projects_images_id.translations.description'
];
const API_INVESTIGATION_PUBLICATION_FIELDS = [
    'publication_section.translations.title',
    'publication_section.publications.rd_publication_id.file',
    'publication_section.publications.rd_publication_id.translations.name'
];
export { API_INVESTIGATION_DETAILS_FIELDS, API_INVESTIGATION_COMMITMENT_FIELDS, API_INVESTIGATION_PROJECTS_FIELDS, API_INVESTIGATION_EVENTS_FIELDS, API_INVESTIGATION_PUBLICATION_FIELDS };
